module.exports = __webpack_public_path__ + "img/3.793592f2.jpg";